import { RuleValidator } from '../types';

export const numberRules: Record<string, RuleValidator> = {
    numeric: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return !isNaN(Number(value));
    },

    integer: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return Number.isInteger(Number(value));
    },

    float: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const num = Number(value);
        return !isNaN(num) && !Number.isInteger(num);
    },

    min: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return Number(value) >= params[0];
    },

    max: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return Number(value) <= params[0];
    },

    between: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const num = Number(value);
        return num >= params[0] && num <= params[1];
    },

    positive: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return Number(value) > 0;
    },

    negative: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return Number(value) < 0;
    },

    multipleOf: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return Number(value) % params[0] === 0;
    }
};